import { useContext } from "react";
import { ActiveFarmContext } from "./context";

export const useActiveFarmContext = () => useContext(ActiveFarmContext);
